export default __webpack_public_path__ + "static/upsidedown-55317a47132b1161bdd43164faf336d1.png";